import { IResult } from '../../../../../../store/admin/roundResults/store';

export const isResult = (item: any): item is IResult => (item as IResult).handicap !== undefined;
